(function (module) {
    'use strict';

    function RootCtrl(WS, Store, moment, $state, $scope, $timeout, utils) {
        this.$onInit = () => {
            this.records = [];
            const account = Store.getCurrentAccount();

            this.setData(account);
            this.addSubscription(account);
            utils.handleAccountChecks({ account, $state });
        };

        this.$onDestroy = () => {
            _.each(this.records, (record) => {
                record.unsubscribe();
                record.discard();
            });
        };

        this.setData = (account) => {
            const { trialLeftString, trialLeftDays, type } = utils.getAccountInfo(account);
            this.type = type;
            if (type === 'free') {
                this.trialLeftString = trialLeftString;
                this.background = '';
                if (trialLeftDays < 8) {
                    this.background = 'orange';
                }
                if (trialLeftDays < 3) {
                    this.background = 'red';
                }
            }
        };

        this.addSubscription = ({ id }) => {
            WS.record.getRecord(`account:${id}`).whenReady((record) => {
                record.subscribe((account) => {
                    this.setData(account);
                    Store.setCurrentAccount(account);
                    utils.handleAccountChecks({ $state, account });

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                }, false);
                this.records.push(record);
            });
        };
    }

    function RootConfig($stateProvider, $translatePartialLoaderProvider, envServiceProvider) {
        // Route
        $stateProvider.state('root', {
            url: '',
            views: {
                'main@': {
                    templateUrl: '/js/components/layouts/vertical-navigation.html',
                    controller: 'RootCtrl as $ctrl',
                },
                'toolbar@root': {
                    templateUrl: '/js/components/toolbar/toolbar.html',
                    controller: 'ToolbarController as $ctrl',
                },
                'navigation@root': {
                    templateUrl: '/js/components/navigation/navigation.html',
                    controller: 'NavigationController as $ctrl',
                },
            },
            bodyClass: 'page--root',
            resolve: {
                isAuthenticated: function ($q, $timeout, User, LoopBackAuth, $location, $state, envService) {
                    const envDefaultURL = envService.read('UI_URI') + '/';
                    const deferred = $q.defer();
                    $timeout(() => {
                        const authenticated = User.isAuthenticated();

                        if (!authenticated) {
                            LoopBackAuth.clearUser();
                            LoopBackAuth.clearStorage();
                            const redirectUrl = $location.absUrl();
                            if (redirectUrl === envDefaultURL) {
                                $state.go('login');
                            } else {
                                $state.go('login', { redirectUrl });
                            }
                        }

                        return deferred.resolve(authenticated);
                    });
                    return deferred.promise;
                },
                currentUser: function (isAuthenticated, $q, User, Includes, LoopBackAuth, $state, Store, $rootScope, $location) {
                    if (!isAuthenticated) return null;

                    return User.getCurrent({ filter: Includes.users })
                        .$promise.then((user) => {
                            if (!user.accountId) {
                                return $state.go('register-account');
                            }

                            if (!user.account || !user.account.accountVerified) {
                                return $state.go('unverified-account');
                            }

                            if (!user.enabled) {
                                return $state.go('blocked-user');
                            }

                            if (!user.emailVerified) {
                                $state.go('verify-email');
                            }

                            if (user.accountId && user.account.id) {
                                Store.setCurrentAccount(user.account);
                                if (!user.account.agreementSigned) {
                                    $state.go('terms-check', {
                                        redirectUrl: $location.absUrl(),
                                    });
                                }
                            }

                            if (!user.isAccountAdmin) {
                                const permissions = _.values(_.get(user, 'permissions', {}));
                                const hasAnyAccess = _.some(permissions);

                                if (!hasAnyAccess) {
                                    return $state.go('root.no-permissions', {
                                        redirectUrl: $location.absUrl(),
                                    });
                                }
                            }

                            return Store.setCurrentUser(user);
                        })
                        .catch((error) => {
                            console.log(error);
                            LoopBackAuth.clearUser();
                            LoopBackAuth.clearStorage();
                            $state.go('login');
                        });
                },
                subAccounts: function (isAuthenticated, currentUser, SubAccount, Store) {
                    if (!isAuthenticated) return null;
                    if (!currentUser) return null;

                    return SubAccount.find()
                        .$promise.then((response) => {
                            if (currentUser.isAccountAdmin) {
                                Store.setCurrentSubAccountId(null);
                                Store.setMultiModelData('subAccounts', response);
                            } else {
                                const enabledSubAccounts = response.filter((subAccount) => {
                                    return _.get(currentUser, `permissions[${subAccount.id}]`) === true;
                                });
                                Store.setMultiModelData('subAccounts', enabledSubAccounts);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            Raven.captureException(error);
                        });
                },
                appTemplates: function (isAuthenticated, currentUser, AppTemplate, Store) {
                    if (!isAuthenticated) return null;
                    if (!currentUser) return null;

                    return AppTemplate.find()
                        .$promise.then((response) => {
                            Store.setMultiModelData('appTemplates', response);
                        })
                        .catch((error) => {
                            console.error(error);
                            Raven.captureException(error);
                        });
                },
            },
        });

        $translatePartialLoaderProvider.addPart('/js/root');
    }

    module.config(RootConfig);
    module.controller('RootCtrl', RootCtrl);
})(angular.module('rocket.components'));
